import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const DesktopDentist = dynamic(() => import('../../components/spa-salon/dentist/DesktopDentist'), {
  loading: () => <Loading />,

});
const MobileDentist = dynamic(() => import('../../components/spa-salon/dentist/MobileDentist'), {
  loading: () => <Loading />,

});

const dentistPOSBillingSoftware = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>Dental Clinic Management & Billing Software in India - Try It Free</title>
        <link rel="canonical" href="https://queuebuster.co/spa-and-salon/dentist-pos-billing-software" />
        <link rel="alternate" href="https://queuebuster.co/spa-and-salon/dentist-pos-billing-software" hrefLang="en-us" />
        <meta name="description" content="Dental clinic management made easy! Simplify billing, appointments, and advance booking with QueueBuster POS. Get started with a free trial." />
        <meta property="og:title" content="Dental Clinic Management & Billing Software in India - Get Started With a Free Trial" />
        <meta property="og:description" content="Experience effortless dental clinic management with QueueBuster POS. Simplify billing, appointments, and advance booking. Start your free trial today." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/dentist.jpg" />
        <meta property="og:url" content="https://queuebuster.co/spa-and-salon/dentist-pos-billing-software" />
      </Head>
         <SchemaTags page="dentist-pos-billing-software" />
      {
        mobileView ? <MobileDentist /> : <DesktopDentist />
      }
    </>
  )
}

export default dentistPOSBillingSoftware